import React from 'react';
import PropTypes from 'prop-types';

import Styled from 'styled-components';

export const NavigationItem = ({active, onClick, children, cy, userpilot}) => {
	const handleOnClick = () => {
		if (onClick) {
			onClick();
		}
	};
	return (
		<SubNavigationItem data-userpilot={userpilot} data-cy={cy} active={active} onClick={handleOnClick}>
			{children}
		</SubNavigationItem>
	);
};

NavigationItem.propTypes = {
	active: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.node,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
};
export const SelectorItem = ({active, onClick, children, cy, userpilot}) => {
	const handleOnClick = () => {
		if (onClick) {
			onClick();
		}
	};
	return (
		<SelectorItemStyle data-userpilot={userpilot} data-cy={cy} active={active} onClick={handleOnClick}>
			{children}
		</SelectorItemStyle>
	);
};
SelectorItem.propTypes = {
	active: PropTypes.bool,
	onClick: PropTypes.func,
	children: PropTypes.node,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
};

export const SubNavigation = ({children, userpilot, cy}) => {
	return (
		<nav data-userpilot={userpilot} data-cy={cy}>
			<List>{children}</List>
		</nav>
	);
};

SubNavigation.SelectorItem = SelectorItem;
SubNavigation.NavigationItem = NavigationItem;
SubNavigation.propTypes = {
	children: PropTypes.node,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
};

const List = Styled.ul`
    margin: 0;
    padding: 0;
    
`;

const SelectorItemStyle = Styled.li`
    color: ${props => (props.active ? '#6e0fea' : '#a1a1a1')};
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-right: 16px;
    display: inline-block;
    cursor: pointer;
    &:hover {
        color: #6e0fea;
        transition: color .3s;
    }
    &:last-child {
        margin-right: 0;
    }
`;

const SubNavigationItem = Styled.li`
    color: ${props => (props.active ? '#6e0fea' : '#535353')};
    border-bottom: ${props => props.active && 'solid 3px #6e0fea'};
    font-weight: ${props => (props.active ? '500' : '400')};
    font-size: 13px;
    margin-right: 20px;
    padding-bottom: 6px;
    display: inline-block;
    cursor: pointer;
    &:hover {
        color: #6e0fea;
        transition: color .3s;
    }
    &:last-child {
        margin-right: 0;
    }
`;
